import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/player-position-stacking/actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class AllowOverlapPrimaryAndSecondaryStacks extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.setAllowOverlapPrimaryAndSecondaryStacks(isChecked));
    }

    render() {
        const {stacking} = this.props;
        const isChecked = stacking.isOverlapPrimaryAndSecondaryStacksAllowed();

        return (
            <InputCheckbox
                label="Allow overlap primary and secondary stacks"
                checked={isChecked} onChange={this.onChange.bind(this)} />
        );
    }
}

function mapStatesToProps(state) {
    const {playerPositionStacking} = state;

    return {
        stacking: playerPositionStacking,
    };
}

export default connect(mapStatesToProps)(AllowOverlapPrimaryAndSecondaryStacks);
